export const PaymentMethods = {
  CREDIT_CARD: 'CREDIT_CARD',
  NO_CREDIT_CARD: 'NO_CREDIT_CARD',
};
